/**
 * Helpers de sécurité — KISS: une fonction = une responsabilité.
 */

/** Liens externes : `noopener noreferrer` obligatoire pour bloquer reverse-tabnabbing. */
export const externalLinkProps = {
  target: "_blank" as const,
  rel: "noopener noreferrer" as const,
};

/** Test rapide si une URL est externe (http/https vers un autre host). */
export const isExternal = (href?: string): boolean => {
  if (!href) return false;
  return /^https?:\/\//i.test(href);
};

/** Anti-injection basique pour des chaînes injectées dans un mailto/wa.me. */
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001F\u007F]/g;
export const sanitizePlainText = (input: string, max = 1000): string =>
  input.replace(CONTROL_CHARS, "").slice(0, max).trim();
